









































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CanBeSizedMixin from '../../mixins/CanBeSizedMixin.vue';
import SlideableMixin from '../../mixins/SlideableMixin.vue';
import { mixins } from 'vue-class-component';
import { IdealoShopModel } from '@/models/Idealo';
import IdealoShop from '@/components/idealo/IdealoShop.vue';
import IdealoDetails from '@/components/idealo/IdealoDetails.vue';
import { Hooper, Slide } from 'hooper';
import 'hooper/dist/hooper.css';
import isotope from '@/components/VueIsotope.vue';

@Component({
  components: {
    IdealoShop,
    IdealoDetails,
    Hooper,
    Slide,
    isotope,
  },
})
export default class IdealoShopList extends mixins(CanBeSizedMixin, SlideableMixin) {
  @Prop() private details!: IdealoShopModel[];
  private activeIdx: number = 0;

  private get chosenOffer() {
    return this.details[this.activeIdx];
  }
  private get detailsHeight() {
    return 500 - Math.abs(Math.min(9, this.details.length) / 3) * 77;
  }

  public get isDataAvailable() {
    return this.details != null && this.details.length > 0;
  }

  private chosen(idx: number) {
    this.activeIdx = idx;
  }

  @Watch('details')
  private reset() {
    this.chosen(0);
    if (!this.small) {
      this.scrollToTop();
    }
  }
}
